"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSProxyService = void 0;
var request_handler_1 = require("../class/request-handler");
var envConfig_1 = require("../envConfig");
var CMSProxy_helper_1 = require("../helpers/CMSProxy.helper");
var Console_helper_1 = require("../helpers/Console.helper");
var common_network_service_1 = require("../network-service/common-network-service");
var CMSProxyService = /** @class */ (function (_super) {
    __extends(CMSProxyService, _super);
    function CMSProxyService() {
        var _this = _super.call(this) || this;
        _this.COMPONENTS_TO_BE_REPLACED = {
        // [MFE_NAMES.tpdLancioUtileASapersiOrdineDescrizione]:
        //   MFE_NAMES.tpdLancioUtileASapersi,
        };
        _this.CMS_PROXY_API = {
            getPages: function () { return _this.getCMSProxyEndpointUrl("pages"); },
            getPageByUrl: function (urlPage) {
                return _this.getCMSProxyEndpointUrl("page", { urlPage: "/tpdweb".concat(urlPage) });
            },
            saveContent: function (contentId, projectId, projectName) {
                return _this.getCMSProxyEndpointUrl("save/content/".concat(contentId), {
                    projectId: projectId,
                    projectName: projectName,
                });
            },
            getContentMenu: function (projectId, projectName) {
                return _this.getCMSProxyEndpointUrl("contents/menu", {
                    projectId: projectId,
                    projectName: projectName,
                });
            },
            getPageContent: function (contentId, projectId, projectName) {
                return _this.getCMSProxyEndpointUrl("contents/".concat(contentId), {
                    projectId: projectId,
                    projectName: projectName,
                });
            },
            getHeader: function (urlPage) {
                return _this.getCMSProxyEndpointUrl("header", { urlPage: "/tpdweb".concat(urlPage) });
            },
            getFooter: function (urlPage) {
                return _this.getCMSProxyEndpointUrl("footer", { urlPage: "/tpdweb".concat(urlPage) });
            },
            getBreadcrumbs: function () { return _this.getCMSProxyEndpointUrl("breadcrumbs"); },
            getSuggestions: function () {
                return _this.getHostEndpointUrl("api/pub/search/tpd/v1/suggestion");
            },
            doSearch: function () { return _this.getHostEndpointUrl("api/pub/search/tpd/v1/search"); },
            getUrlsCMS: function () { return _this.getCMSProxyEndpointUrl("getUrlsCMS"); },
            getImages: function () { return _this.getCMSProxyEndpointUrl("images"); },
            getRemotesEntries: function () { return _this.getCMSProxyEndpointUrl("remotes-entries"); }, // TODO: DEPRECATED, need to remove it
        };
        return _this;
    }
    // TODO: DEPRECATED, need to remove it
    CMSProxyService.prototype.getRemotesEntries = function (networkConfig) {
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve(envConfig_1.COMMON_ENV_CONFIG.REMOTES_ENTRIES)];
            });
        });
    };
    CMSProxyService.prototype.getPages = function (networkConfig) {
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Console_helper_1.ConsoleHelper.log("[Request] getPages");
                        commonNetworkService = new common_network_service_1.CommonNetworkService(networkConfig);
                        return [4 /*yield*/, this.handleRequest(function () { return commonNetworkService.get(_this.CMS_PROXY_API.getPages(), {}, true); }, 3)];
                    case 1:
                        response = _a.sent();
                        Console_helper_1.ConsoleHelper.log("<Response> getPages", response);
                        return [2 /*return*/, response.content.data];
                }
            });
        });
    };
    CMSProxyService.prototype.getHeader = function (url, networkConfig) {
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Console_helper_1.ConsoleHelper.log("[Request] getHeader");
                        commonNetworkService = new common_network_service_1.CommonNetworkService(networkConfig);
                        return [4 /*yield*/, this.handleRequest(function () {
                                return commonNetworkService.get(_this.CMS_PROXY_API.getHeader(url), {}, true);
                            }, 3)];
                    case 1:
                        response = _a.sent();
                        Console_helper_1.ConsoleHelper.log("<Response> getHeader", response);
                        return [2 /*return*/, (response && response.content && response.content.data) || {}];
                }
            });
        });
    };
    CMSProxyService.prototype.getFooter = function (url, networkConfig) {
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Console_helper_1.ConsoleHelper.log("[Request] getFooter");
                        commonNetworkService = new common_network_service_1.CommonNetworkService(networkConfig);
                        return [4 /*yield*/, this.handleRequest(function () {
                                return commonNetworkService.get(_this.CMS_PROXY_API.getFooter(url), {}, true);
                            }, 3)];
                    case 1:
                        response = _a.sent();
                        Console_helper_1.ConsoleHelper.log("<Response> getFooter", response);
                        return [2 /*return*/, response.content.data];
                }
            });
        });
    };
    CMSProxyService.prototype.getBreadcrumbs = function (url, title, networkConfig) {
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var breadcrumbs, newUrl, pageProps, title_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Console_helper_1.ConsoleHelper.log("[Request] getBreadcrumbs", url);
                        breadcrumbs = [];
                        if (!url.startsWith("http")) return [3 /*break*/, 1];
                        breadcrumbs = [{ url: url, title: title }];
                        return [3 /*break*/, 7];
                    case 1:
                        newUrl = url;
                        if (!newUrl.startsWith("/")) {
                            newUrl = "/" + newUrl;
                        }
                        if (newUrl.endsWith("/")) {
                            newUrl = newUrl.substring(0, newUrl.length - 1);
                        }
                        breadcrumbs = [{ url: newUrl, title: title }];
                        _a.label = 2;
                    case 2:
                        if (!(newUrl.lastIndexOf("/") !== 0)) return [3 /*break*/, 7];
                        newUrl = newUrl.substring(0, newUrl.lastIndexOf("/"));
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.getPageByUrl(newUrl, networkConfig)];
                    case 4:
                        pageProps = _a.sent();
                        title_1 = pageProps.title || "";
                        breadcrumbs.unshift({ url: newUrl, title: title_1 });
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 2];
                    case 7:
                        Console_helper_1.ConsoleHelper.log("<Response> getBreadcrumbs", breadcrumbs);
                        return [2 /*return*/, breadcrumbs];
                }
            });
        });
    };
    // TODO: DEPRECATED, need to remove it
    CMSProxyService.prototype.getUrlsCMS = function (networkConfig) {
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Console_helper_1.ConsoleHelper.log("[Request] getUrlsCMS");
                        commonNetworkService = new common_network_service_1.CommonNetworkService(networkConfig);
                        return [4 /*yield*/, this.handleRequest(function () {
                                return commonNetworkService.get(_this.CMS_PROXY_API.getUrlsCMS(), {}, true);
                            })];
                    case 1:
                        response = _a.sent();
                        Console_helper_1.ConsoleHelper.log("<Response> getUrlsCMS", response);
                        return [2 /*return*/, response.content.data];
                }
            });
        });
    };
    CMSProxyService.prototype.getPageByUrl = function (url, networkConfig) {
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Console_helper_1.ConsoleHelper.log("[Request] getPageByUrl", url);
                        commonNetworkService = new common_network_service_1.CommonNetworkService(networkConfig);
                        return [4 /*yield*/, this.handleRequest(function () {
                                return commonNetworkService.get(_this.CMS_PROXY_API.getPageByUrl(url), {}, true);
                            })];
                    case 1:
                        response = _a.sent();
                        if (response) {
                            Console_helper_1.ConsoleHelper.log("<Response> getPageByUrl", response);
                            return [2 /*return*/, CMSProxy_helper_1.CMSProxyHelper.replaceComponentsName(response.content.data, this.COMPONENTS_TO_BE_REPLACED)];
                        }
                        else {
                            throw { errorCode: 404, message: "".concat(url, " Page Not Found") };
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // TODO: DEPRECATED, need to remove it
    CMSProxyService.prototype.getImages = function (networkConfig) {
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Console_helper_1.ConsoleHelper.log("[Request] getImages");
                        commonNetworkService = new common_network_service_1.CommonNetworkService(networkConfig);
                        return [4 /*yield*/, this.handleRequest(function () {
                                return commonNetworkService.get(_this.CMS_PROXY_API.getImages(), {}, true);
                            })];
                    case 1:
                        response = _a.sent();
                        Console_helper_1.ConsoleHelper.log("<Response> getImages", response);
                        return [2 /*return*/, response.content.data];
                }
            });
        });
    };
    CMSProxyService.prototype.saveDescription = function (contentId, projectId, projectName, description, contentName, networkConfig) {
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        commonNetworkService = new common_network_service_1.CommonNetworkService(networkConfig);
                        return [4 /*yield*/, this.handleRequest(function () {
                                return commonNetworkService.put(_this.CMS_PROXY_API.saveContent(contentId, projectId, projectName), JSON.stringify({
                                    name: contentName,
                                    description: description,
                                }), {}, true);
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CMSProxyService.prototype.saveContent = function (contentId, projectId, projectName, elements, keywords, contentName, networkConfig) {
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        commonNetworkService = new common_network_service_1.CommonNetworkService(networkConfig);
                        return [4 /*yield*/, this.handleRequest(function () {
                                return commonNetworkService.put(_this.CMS_PROXY_API.saveContent(contentId, projectId, projectName), JSON.stringify({
                                    name: contentName,
                                    elements: elements.map(function (_a) {
                                        var type = _a.type, name = _a.name, value = _a.value;
                                        return ({
                                            type: type,
                                            name: name,
                                            value: value,
                                        });
                                    }),
                                    keywords: keywords,
                                }), {}, true);
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CMSProxyService.prototype.getPageContent = function (content_id, project_id, project_name, networkConfig) {
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Console_helper_1.ConsoleHelper.log("[Request] getPageContent");
                        commonNetworkService = new common_network_service_1.CommonNetworkService(networkConfig);
                        return [4 /*yield*/, this.handleRequest(function () {
                                return commonNetworkService.get(_this.CMS_PROXY_API.getPageContent(content_id, project_id, project_name), {}, true);
                            }, 3)];
                    case 1:
                        response = _a.sent();
                        Console_helper_1.ConsoleHelper.log("<Response> getPageContent", response.content);
                        return [2 /*return*/, response.content];
                }
            });
        });
    };
    CMSProxyService.prototype.getContentMenu = function (dataContentId, project_id, project_name, menuName, siteAreaName, pageNum, rows, networkConfig) {
        if (pageNum === void 0) { pageNum = 1; }
        if (rows === void 0) { rows = 3; }
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Console_helper_1.ConsoleHelper.log("[Request] getContentMenu");
                        commonNetworkService = new common_network_service_1.CommonNetworkService(networkConfig);
                        return [4 /*yield*/, this.handleRequest(function () {
                                return commonNetworkService.post(_this.CMS_PROXY_API.getContentMenu(project_id, project_name), JSON.stringify({
                                    dataContentId: dataContentId,
                                    menuName: menuName,
                                    pageNum: pageNum,
                                    rows: rows,
                                    siteAreaName: siteAreaName,
                                }), {}, true, true);
                            })];
                    case 1:
                        response = _a.sent();
                        Console_helper_1.ConsoleHelper.log("<Response> getContentMenu", response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CMSProxyService.prototype.getSuggestions = function (data, networkConfig) {
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        commonNetworkService = new common_network_service_1.CommonNetworkService(networkConfig);
                        return [4 /*yield*/, this.handleRequest(function () {
                                return commonNetworkService.post(_this.CMS_PROXY_API.getSuggestions(), JSON.stringify(data), {}, true);
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CMSProxyService.prototype.doSearch = function (data, networkConfig) {
        if (networkConfig === void 0) { networkConfig = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        commonNetworkService = new common_network_service_1.CommonNetworkService(networkConfig);
                        return [4 /*yield*/, this.handleRequest(function () {
                                return commonNetworkService.post(_this.CMS_PROXY_API.doSearch(), JSON.stringify(data), {}, true);
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CMSProxyService.className = "CMSProxyService";
    return CMSProxyService;
}(request_handler_1.RequestHandler));
exports.CMSProxyService = CMSProxyService;
